<template>
  <span>
    <v-chip role="matrix-status-badge" :color="matrixStatusColor" x-small>{{ displayedIndex }}</v-chip>
    <v-icon v-if="hasCriticalError" :color="matrixStatusColor">mdi-alert</v-icon>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import { getStatusColor, matrix } from '@/modules/matrix';

export default Vue.extend({
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    displayedIndex(): number {
      return this.index + 1;
    },
    matrixStatusColor(): string {
      return getStatusColor(this.index);
    },
    hasCriticalError(): boolean {
      return matrix.elements[this.index].status.isCritical ?? false;
    }
  }
});
</script>
